import { NgModule } from '@angular/core';
import { EventCodeStylePipe } from './event-code-style';

@NgModule({
  declarations: [EventCodeStylePipe],
  exports: [EventCodeStylePipe],
})
export class StyleClassModule {}
